<template>
  <div id="app" ref='boxH' :class="routerName == 'login' ? 'pBto' : ''" @click.prevent="dialogHide = true">
    <topHead v-show="routerName != 'login'" />
    <router-view v-if="isRouterAlive"></router-view>
    <foot v-show="routerName != 'login'" />
    <playAudio v-show="routerName != 'login'" :dialog-hide="dialogHide"  @dialogShow="sonReturnDialogHide" />
  </div>
</template>

<script>
import topHead from './components/head.vue';
import foot from './components/foot.vue';
import playAudio from './components/playAudio.vue';

export default {
  name: 'app',
  components: {
    topHead,
    foot,
    playAudio,
  }, 
  data() {
    return {
      dialogHide: false,
    }
  },
  computed: {
    deptId() {
      return this.$store.state.deptId;
    },
    isRouterAlive() {
      return this.$store.state.isRouterAlive;
    },
    // isShowLoginBox() {
    //   return this.$store.state.isShowLoginBox;
    // },
    routerName() {
      return this.$route.name;
    }
  },
  created() {
    let that = this;
    // console.log(location.hostname.split(".")[0])
    // 不同图书馆域名不一样进行不同的登录方式
    localStorage.setItem("loginName", location.hostname.split(".")[0]);
  },
  mounted() {
    let that = this;
    that.theme();
    if( !localStorage.getItem("dept") ) {
      return false;
    }
    
    that.$store.commit("setDeptId", localStorage.getItem("dept"));
  },
  methods: { 
    extraClick(item) {
      let that = this;
      if( item.name == "goTop" ) {
        that.scrollTopFn();
      }
    },
    theme() {
      window.document.documentElement.setAttribute("data-theme", 108);
    },
    sonReturnDialogHide() {
      let that = this;
      that.dialogHide = false;
    }
  },
  watch: {
    routerName() {
      let that = this;
      that.$refs.boxH.scrollTop = 0;
    }
  }
}
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  position: relative;
  padding-bottom: 150px;
  &.pBto{
    padding-bottom: 0;
  }
}
</style>
